import reducer from './reducer';

import * as ConfigSelectors from './selectors';
import * as ConfigOperations from './operations';
import * as ConfigTypes from './actions';

export { ConfigSelectors, ConfigOperations, ConfigTypes };

export default reducer;
